import Table from '../Components/AdminTable.js'
import { useEffect, useState } from 'react'
import { call } from '../Methods.js'
import FormModal from '../Components/FormModal.js'

function Teachers () {  
  const pageName = 'teachers'
  const pageTitle = 'Müəllimlər / Mentorlar'
  document.title = `${pageTitle} | ${process.env.REACT_APP_NAME}`
  const [updateTable, setUpdateTable] = useState(false)

  useEffect(() => {
    if (updateTable) {
      setUpdateTable(false)
    }
  }, [updateTable])

  const tableSettings = {
    name: '',
    label: '',
    filters: true,
    pagination: true,
    editLink: rowData => `/${pageName}/${rowData.id}`,
    actions: {
      get: async (params = {}) => {
        const teachers = await call.forLoggedUser.teacher.getTeachers(params)
        if (teachers.success) {
          return teachers.data
        }
        return []
      }
    },
    columns: [
      {
        title: '#',
        property: 'rowNumber',
        style: { width: '30px' },
        filter: {
          enabled: false
        }
      },
      {
        title: 'Adı, Soyadı, Atasının adı',
        property: ['name', 'surname'],
        style: { width: '30%' },
        filter: {
          enabled: true,
          type: 'text',
          name: 'name'
        },
        mutate: values => {
          return values[0] + ' ' + values[1]
        }
      },
      {
        title: 'Fənn(lər)',
        type: 'labels',
        property: 'subjectList',
        style: { width: '20%' },
        filter: {
          enabled: true,
          type: 'select',
          name: 'subjectId',
          dataSource: async () => {
            const source = await call.forLoggedUser.subject?.getSubjects({})
            let data = source.data?.map(d => {
              return { value: d.id, text: d.name }
            })
            return data
          }
        },
        mutate:(value)=>{
          return value?.map(s=>s.subjectName)
        }
      },
      {
        title: 'Telefon',
        property: ['phone1', 'phone2'],
        filter: {
          enabled: true,
          type: 'tel',
          name: 'phone'
        },
        style: { width: '15%' },
        mutate: values => {
          return `${values[0]}${values[1] ? ' / ' + values[1] : ''}`
        }
      },
      {
        title: 'E-poçt',
        property: 'email',
        filter: {
          enabled: true,
          type: 'email',
          name: 'email'
        },
        style: { width: '15%' }
      },
      {
        title: 'Status',
        property: 'statusName',
        type:'status-label',
        filter: {
          enabled: true,
          type: 'select',
          name: 'statusId',
          dataSource: async () => {
            const source = await call.forLoggedUser.status.getStatuses({
              type: 'teacher'
            })
            let data = source.data.map(d => {
              return { value: d.id, text: d.description }
            })
            return data
          }
        },
        style: { width: '10%' },
        mutate: value => {
          return value
        }
      },
      {
        title: 'Əməliyyat',
        property: ['id'],
        type: 'operations-list',
        operations:(values)=>[
          {
            type:'group',
            name:'menu',
            title:'Group',
            icon:'...',
            items:[
              {
                type:'command',
                name:'delete',
                title:'Qeydi sil',
                parameters:JSON.stringify({id:values[0],entity:'teacher'}),
                iconType:'path',
                icon:'/Images/Icons/delete.png',
                disablingConditions:[]
              }
            ]
          }
        ],
        style: {width:'5%',minWidth: '120px'}
      }
    ],
    addNew: {
      enabled: true,
      url: `/${pageName}/add`,
      title: '+ Əlavə et'
    }
  }

  const formSettings = [
    {
      name: 'teacher',
      label: 'Müəllim',
      isStandAlone: true,
      isMain: true,
      actions: {
        get: id => call.forLoggedUser.teacher.getTeacherById({ id: id }),
        add: call.forLoggedUser.teacher.addTeacher,
        edit: call.forLoggedUser.teacher.updateTeacher
      },
      formLists: {
        Genders: async () => {
          const source = await call.forLoggedUser.listOption.getListOptions({
            listName: 'Gender'
          })
          return source.data.map(d => {
            return { value: d.value, text: d.text }
          })
        },
        Statuses: async () => {
          const source = await call.forLoggedUser.status.getStatuses({
            type: 'teacher'
          })
          return source.data.map(d => {
            return { value: d.id, text: d.description }
          })
        },
        Subjects: async () => {
          const source = await call.forLoggedUser.subject.getSubjects({})
          return source.data.map(s => {
            return { value: s.id, text: s.name }
          })
        },
        Branches: async () => {
          const source = await call.forLoggedUser.branch.getBranches({})
          return source.data.map(s => {
            return { value: s.id, text: s.name }
          })
        }
      },
      fields: [
        { type: 'hidden', fieldName: 'id', label: '' },
        {
          label: 'Adı',
          fieldName: 'name',
          validationRules: ['required'],
          col: { sm: 3 }
        },
        {
          label: 'Soyadı',
          fieldName: 'surname',
          validationRules: ['required'],
          col: { sm: 3 }
        },
        {
          label: 'Atasının adı',
          fieldName: 'middleName',
          col: { sm: 2 }
        },
        {
          label: 'Cinsiyyəti',
          type: 'select',
          fieldName: 'gender',
          col: { sm: 2 },
          data: 'Genders'
        },
        {
          label: 'Doğum tarixi',
          type: 'date',
          fieldName: 'birthDate',
          col: { sm: 2 },
          mutate: value => {
            return new Date(value).toLocaleDateString('az-AZ')
          }
        },
        {
          label: 'Telefon 1',
          fieldName: 'phone1',
          validationRules: ['required'],
          col: { sm: 2 }
        },
        {
          label: 'Telefon 2',
          fieldName: 'phone2',
          col: { sm: 2 }
        },
        {
          label: 'E-poçt',
          type: 'email',
          fieldName: 'email',
          col: { sm: 2 }
        },
        {
          label: 'Ünvan',
          type: 'text',
          fieldName: 'address',
          col: { sm: 4 }
        },
        {
          label: 'Status',
          type: 'select',
          fieldName: 'statusId',
          defaultValue: 1,
          col: { sm: 2 },
          data: 'Statuses'
        },

        {
          label: 'Fənn(lər)',
          type: 'select-multiple',
          fieldName: 'subjects',
          validationRules: ['required'],
          data: 'Subjects',
          col: { sm: 12 }
        },
        {
          label: 'Filial(lar)',
          type: 'select-multiple',
          fieldName: 'branches',
          validationRules: ['required'],
          data: 'Branches',
          col: { sm: 12 }
        },
        {
          label: 'Əlavə qeydlər',
          type: 'textarea',
          fieldName: 'notes',
          col: { sm: 12 }
        },
        { type: 'submit', label: 'Təsdiq', col: { sm: 12 } }
      ]
    }
  ]

  return (
    <div className='page'>
      <h1 className='page-title'>Müəllimlər</h1>
      <Table tableSettings={tableSettings} updateTable={updateTable} />

      <FormModal
        moduleUrl={`/${pageName}`}
        formSettings={formSettings}
        onSubmit={() => setUpdateTable(true)}
      />
    </div>
  )
}

export default Teachers
